// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"b7587671","213":"cc6124e7","227":"0a7b0f01"}[chunkId] + ".chunk.js";
};